import { render, staticRenderFns } from "./UkrTreasuresStep.vue?vue&type=template&id=39bd7ed4&scoped=true"
import script from "./UkrTreasuresStep.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresStep.vue?vue&type=script&lang=js"
import style0 from "./UkrTreasuresStep.vue?vue&type=style&index=0&id=39bd7ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd7ed4",
  null
  
)

export default component.exports